module.exports = __webpack_public_path__ + "static/media/forward.32f9351c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/forward.svg
// module id = 257
// module chunks = 0